import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DashboardLayout } from "../layouts/dashboard.layout";
import { ProtectedRoute } from "./protected-route";
import { Dashboard } from "../modules/dashboard";
import { NotFound } from "../modules/404";
import { CustomersRouter } from "../modules/customers/customers.router";
import { ContactsRouter } from "../modules/contacts/contacts.router";
import { ProspectionsRouter } from "../modules/prospections/prospections.router";
import { MailboxesRouter } from "../modules/mailboxes/mailboxes.router";
import { MailMessagesRouter } from "../modules/mail-messages/mail-messages.router";
import { CmsRouter } from "../modules/cms/cms.router";
import { ReportsRouter } from "../modules/reports/reports.router";
import { ArticlesRouter } from "../modules/articles/articles.router";
import { TutoRouter } from "../modules/tuto/tuto.router";
import { CreatedSitesRouter } from "../modules/created-sites/created-sites.router";
import { CustomerTasksRouter } from "../modules/customer-tasks/customer-tasks.router";
import { NotificationsRouter } from "../modules/notifications/notifications.router";

export const ClientRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          <Route element={<ProtectedRoute roles={["Any"]} />}>
            <Route path="/" element={<Dashboard />} />
          </Route>
          {CustomersRouter}
          {ContactsRouter}
          {ProspectionsRouter}
          {MailboxesRouter}
          {MailMessagesRouter}
          {CmsRouter}
          {ReportsRouter}
          {ArticlesRouter}
          {TutoRouter}
          {CreatedSitesRouter}
          {CustomerTasksRouter}
          {NotificationsRouter}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
